export const UserStatus = {
  ACTIVE: { id: 0, name: "Activo" },
  DELETED: { id: 1, name: "Eliminado" },
  BLOCKED: { id: 2, name: "Bloqueado" }
};

export const getUserStatus = (id: number) => Object.values(UserStatus).find(item => item.id === id);

export const getAllUserStatus = () => Object.values(UserStatus);
